import CrudPage from "@/components/CrudPage";

const fields = [
  { key: "nome", label: "Nome", placeholder: "Ex.: Intervalo" },
  { key: "codigo", label: "Codigo", mono: true, placeholder: "INTERVALO" },
  { key: "limite_minutos", label: "Franquia diaria em minutos", type: "number", hint: "A soma das pausas de cada agente nao pode ultrapassar este limite no dia." },
  { key: "enabled", label: "Ativo", type: "toggle" },
];

export default function PauseReasons() {
  return <CrudPage
    title="Opcoes de pausa"
    subtitle="Motivos disponiveis para os agentes, com franquia diaria acumulada por pausa"
    endpoint="/callcenter-pause-reasons"
    testidPrefix="callcenter-pause-reasons"
    fields={fields}
    headers={["Nome", "Codigo", "Franquia diaria", "Status"]}
    defaultValues={{ nome: "", codigo: "", limite_minutos: 0, enabled: true }}
    transformSubmit={(form)=>({...form, codigo:String(form.codigo || form.nome || "").trim().toUpperCase().replace(/[^A-Z0-9_-]+/g,"_"), limite_minutos:Number(form.limite_minutos || 0)})}
    renderRow={(row)=><><td>{row.nome}</td><td className="font-mono">{row.codigo}</td><td className="font-mono">{row.limite_minutos ? `${row.limite_minutos} min` : "Sem limite"}</td><td>{row.enabled ? <span className="sbc-tag tag-online">Ativa</span> : <span className="sbc-tag tag-offline">Inativa</span>}</td></>}
  />;
}
